import React from 'react';
import { useAppSelector } from '../../../../../store/hooks';
import { rectificationLinksFiltersSelector } from '../../../../../store/selectors/rectificationsSelector';
import LinksColumns from '../../../../../common/components/links-table/LinksColumns';
import { useLinks } from '../../../../../common/hooks/useLinks';
import { setRectificationLinksFilters } from '../../../../../store/slices/rectificationsSlice';

type RectificationLinksColumnsProps = {
  totalCount: number,
}
const RectificationLinksColumns: React.FC<RectificationLinksColumnsProps> = ({ totalCount }) => {
  const linksFilters = useAppSelector(rectificationLinksFiltersSelector);

  const {
    onChangeSearchHandle,
    searchPressHandle,
    searchVl,
    pickerValue,
    setPickerValue,
    pickerHandle,
  } = useLinks(linksFilters, setRectificationLinksFilters);

  return (
    <LinksColumns
      totalCount={totalCount}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      searchVl={searchVl}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
      tableFilters={linksFilters}
    />
  );
};

export default RectificationLinksColumns;
